import { createFileRoute } from '@tanstack/react-router';

import { EvidenceRunPage } from '@/features/labour-evidence/run-page';

export const Route = createFileRoute('/_app/projects/$projectId/labour-evidence/payroll/$runId')({
  component: EvidenceRunRoute,
});

function EvidenceRunRoute() {
  const { projectId, runId } = Route.useParams();
  return <EvidenceRunPage projectId={projectId} runId={runId} />;
}
